"use client"

import "./globals.css";
import '@mantine/core/styles.css';

import {ColorSchemeScript, MantineProvider} from '@mantine/core';
import {NextUIProvider} from "@nextui-org/react";
import React, {useEffect, useState} from "react";
import {SessionProvider} from "next-auth/react";
import {usePathname} from "next/navigation";


import {notoSansTC as notoSansfTC} from "@/styles/fonts";
import cx from "clsx";
import Script from 'next/script'
import IdentityControls from "@/components/impersonation/IdentityControls";

// export const metadata = {
//     title: '臺灣學術會議資訊平台 Taiwan Conference Commons',
//     description: '臺灣學術會議資訊平台 Taiwan Conference Commons',
// };




export default function RootLayout({children}: { children: React.ReactNode }) {
    const pathname = usePathname();
    const [fullBackground, setFullBackground] = useState(false);

    const [backImage, setBackImage] = useState<String | null>(null);

    useEffect(() => {
        // if(id == '1'){
        //
        // }
        // else if(id == '2'){
        //     setBackImage('istockphoto-1209978764-1024x1024.jpg');
        // }
        // else {
        //     setBackImage('istockphoto-1360633055-1024x1024.jpg');
        // }
        setBackImage('iStock-1144122761.jpg');
        setFullBackground(pathname == "/login")
    }, [pathname]);



    const backgroundStyle = fullBackground ? {
        backgroundImage: `url('/${backImage}')`,
        backgroundPosition: "center 0px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        minHeight: "100vh"
    } : {};

    return (
        <html lang="en" >
        <head>

            {/* GA Part 1 */}
            <Script
                src="https://www.googletagmanager.com/gtag/js?id=G-ZW6913209W"
                strategy="afterInteractive"
            />
            {/* GA Part 2 */}
            <Script id="google-analytics" strategy="afterInteractive">
                {`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-ZW6913209W');`}
            </Script>

            <title>臺灣學術會議資訊平台</title>
            <ColorSchemeScript/>
            <link rel="icon" href="/favicon.svg" sizes="any"/>
        </head>
        <body style={backgroundStyle}
              className={cx(notoSansfTC.className, 'bg-[#f6f8f9]')}>

        <div>
            <MantineProvider defaultColorScheme="light">
                <NextUIProvider>
                    <SessionProvider refetchInterval={30} refetchOnWindowFocus>
                        <IdentityControls/>
                        {children}
                    </SessionProvider>
                </NextUIProvider>
            </MantineProvider>
        </div>


        </body>
        </html>
    );
}
